import css from "./Details.module.css";
import AddButton from "../../../../Components/Form/AddButton/AddButton";
import { ModalAction } from "../../../../Routes/NavRouter";
import { Post, Get, Put, Delete } from "../../../../Services/Server";
import AddContactModal from "../../../../Modals/AddContactModal/AddContactModal";
import Url from "../../../../Services/Url";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import Svg from "../../../../Components/Svg/Svg";
import SvgOptions from "../../../../Components/Svg/SvgOptions";

const Right = ({ state }) => {
	const [company, setCompany] = useState(state);
	const [contacts, setContacts] = useState([]);
	const { openModal, closeModal } = ModalAction;

	useEffect(() => {
		if (company?.id) {
			Get(Url.contact(company.id, "e")).then((resp) => {
				setContacts(resp || []);
			});
		}
	}, [company?.id]);

	const handleAddContact = () => {
		const option = {
			element: AddContactModal,
			title: "Add Contact",
			closeModal: async (newContact) => {
				try {
					const data = { ...newContact, companyId: company.id };
					const created = await Post(Url.contact(company.id, "e"), data);
					setContacts((prev) => [...prev, created]);
					toast("Contact added");
				} catch(error) {
					toast.error("Failed to add contact");
				}
				closeModal();
			},
			companyId: company.id,
		};
		openModal(option);
	};

	const handleEdit = async (updatedContact) => {
		try {
			const updated = await Put(Url.updateContact(updatedContact.id), updatedContact);
			setContacts((prev) =>
				prev.map((c) => (c.id === updated.id ? updated : c))
			);
			toast("Contact updated");
		} catch (err){
			toast.error("Failed to update contact");
		}
	};

	const handleDelete = (contactToDelete) => {
		ModalAction.confirm({
			title: "Deleting Contact?",
			text: "You are about to delete this contact.",
			exitText: "Close",
			okText: "Delete",
			onOk: async () => {
				try {
					await Delete(Url.updateContact(contactToDelete.id));
					setContacts((prev) => prev.filter((c) => c.id !== contactToDelete.id));
					toast("Contact deleted");
				} catch (err) {
					toast.error("Failed to delete contact");
				}
			},
		});
	};

	return (
		<div className={css.Right}>
			<div className={css.Title}>
				Contacts
			</div>
			<div className={css.Vessels}>
				{contacts.map((contact) => (
					<ContactItem
						key={contact.id}
						contact={contact}
						onEdit={handleEdit}
						onDelete={handleDelete}
					/>
				))}
				<AddButton onClick={handleAddContact}>Add Contact</AddButton>
			</div>
		</div>
	);
};

const ContactItem = ({ contact, onEdit, onDelete }) => {
	const { openModal, closeModal } = ModalAction;

	const handleEdit = () => {
		const option = {
			element: AddContactModal,
			title: "Edit Contact",
			closeModal: (updated) => {
				onEdit({ ...contact, ...updated });
				closeModal();
			},
			...contact,
		};
		openModal(option);
	};

	return (
		<div className={css.Vessel}>
			<div>
				<div className={css.Name}>
					{contact.firstname} {contact.lastname}
				</div>
				<div className={css.Email}>{contact.email}</div>
			</div>
			<div className={css.VesselControls}>
				<div className={css.Edit}>
					<Svg onClick={handleEdit} className="Icon">
						{SvgOptions.Edit}
					</Svg>
				</div>
				<div className={css.Delete}>
					<Svg onClick={() => onDelete(contact)} className={css.Icon}>
						{SvgOptions.Delete}
					</Svg>
				</div>
			</div>
		</div>
	);
};

export default Right;
